<template>
	<div>
		<Row style="padding-top: 20px;">
			<Form :label-width="80">
				<FormItem label="条件">
					<Select filterable v-model="city" clearable style="width:200px" placeholder="城市">
						<Option v-for="item in cityList" :value="item.city" :key="item.city">{{ item.city }}</Option>
					</Select>

					<Input v-model="name" style="width:200px;margin-left: 10px;" placeholder="请输入姓名/电话号码"></Input>
					<Button style="margin-left: 20px;" type="primary" v-on:click="mySearch()">查询</Button>
					<Button style="margin-left: 20px;" type="primary" v-on:click="initSearch()">重置</Button>
					<Button type="primary" style="margin-left: 20px;" @click="addInter">添加接口</Button>
				</FormItem>
			</Form>
		</Row>
		<Table border :columns="columns" :data="datas">
			<template slot-scope="{ row }" slot="distributeNum">
				<div>
					<span>{{row.max_count}} | {{row.cur_count}}</span>
				</div>
			</template>
			<template slot-scope="{ row, index }" slot="status">
				<i-switch v-model="datas[index].status" size="large" @on-change="saveOpen($event, index)">
					<span slot="open">启用</span>
					<span slot="close">暂停</span>
				</i-switch>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
					@click="editInter">编辑</Button>
				<Button type="error" size="small" :data-id="row.id" @click="delClientRecoverSet">删除</Button>
			</template>
		</Table>
		<Modal v-model="interModal" title="添加接口" width = '1000px' @on-ok="save">
			<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
				<Form :model="formItem" :label-width="100">
					<FormItem label="接口名称">
						<Input v-model="formItem.des">
						</Input>
					</FormItem>
					<FormItem label="所属下游客户">
						<Select v-model="formItem.uid">
							<Option v-for="item in clientList" :value="item.id" :key="item.id">
								{{ item.username }}[{{item.id}}]
							</Option>
						</Select>
					</FormItem>
					<FormItem label="提交数量/天">
						<Input v-model="formItem.max_count">
						</Input>
					</FormItem>
					<FormItem label="城市">
						<Input v-model="formItem.city">
						</Input>
					</FormItem>
					<FormItem label="最大贷款金额">
						<Input v-model="formItem.loan_max">
						</Input>
					</FormItem>
					<FormItem label="最小贷款金额">
						<Input v-model="formItem.loan_min">
						</Input>
					</FormItem>
					<FormItem label="是否为失败数据">
						<Input v-model="formItem.fail">
						</Input>
					</FormItem>
					<FormItem label="优先级(数字大优先级高)">
						<Input v-model="formItem.level">
						</Input>
					</FormItem>
					<FormItem label="来源">
						<div class="multiple" style="margin-top: 0">
							<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
								<span>全选</span>
							</Checkbox>
							<CheckboxGroup v-model="formItem.cid_str" @on-change="checkAllGroupChange">
								<Checkbox v-for="item in cidList" :label="item.id"><span>{{item.username}}</span></Checkbox>
							</CheckboxGroup>
						</div>
					</FormItem>
					<!--FormItem label="资质条件">
						<div class="multiple" style="margin-top: 0">
							<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
								<span>全选</span>
							</Checkbox>
							<CheckboxGroup v-model="condition" @on-change="checkAllGroupChange">
								<Checkbox v-for="item in statusFilters" :label="item.value"><span>{{item.label}}</span></Checkbox>
							</CheckboxGroup>
						</div>
					</FormItem-->
				</Form>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		getInterList,
		saveInterStatus,
		getInter,
		getSystemDataList,
		saveInter,
	} from "../../api/advManage";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		data() {
			return {
				formItem: {
					name: '',
					city: '',
				},
				columns: [{
						title: "编号",
						type: "index",
						align: 'center'
					},
					{
						title: "下游客户",
						key: "username",
						align: 'center'
					},
					{
						title: "接口ID",
						key: "uid",
						align: 'center'
					},
					{
						title: "接口描述",
						key: "des",
						align: 'center'
					},
					{
						title: "城市",
						key: "city",
						align: 'center'
					},
					{
						title: "（系统）限量|已提交",
						slot: "distributeNum",
						align: 'center'
					},
					{
						title: "最后提交数据时间",
						key: "last_time",
						align: 'center'
					},
					{
						title: "最后更新时间",
						key: "time",
						align: 'center'
					},
					{
						title: "状态",
						slot: "status",
						align: 'center'
					},
					{
						title: "操作",
						slot: "action",
						align: 'center'
					},
				],
				statusFilters: [{
					label: '房',
					value: 'houses'
				}, {
					label: '车',
					value: 'car'
				}, {
					label: '公积金',
					value: 'epf_time'
				}, {
					label: '社保',
					value: 'social_security'
				}, {
					label: '保单',
					value: 'life_policy'
				}],
				indeterminate: true,
				checkAll: false,
				condition:[],
				interModal: false,
				datas: [],
				clientList:[],
				cidList:[],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
				};
				var data = {
					token: that.token,
				};
				var res = await getSystemDataList(that, data);
				if (res.code == 1) {
					that.cidList = res.data.cidList;
					that.clientList = res.data.clientList;
				}
			},
			save() {
				let that = this;
				that.throttle(async function() {
					let data = {
						token: that.token,
						data: that.formItem
					};
					let res = await saveInter(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						this.getList();
					}
				}, 500)
			},
			saveOpen(e, index) {
				let item = this.datas[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					status: item.status
				};
				this.throttle(async function() {
					let res = await saveInterStatus(that, data);
					if (res.code == 1) {
						this.getList();
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			addInter(){
				this.interModal = true;
			},
			async editInter(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id
				};
				let res = await getInter(that, data);
				if (res.code == 1) {
					that.formItem = res.data.item;
					that.interModal = true;
				}
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;
			
				if (this.checkAll) {
					for (let i in this.cidList) {
						this.formItem.cid_str.push(this.cidList[i].id);
					}
				} else {
					this.formItem.cid_str = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 3) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.order_type = that.order_type;
				let res = await getInterList(that, data);
				that.datas = res.data.interList;
			},
		},
	};
</script>

<style lang="less" scoped>
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>